import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSelector = ({ className = '' }) => {
  const { language, setLanguage, availableLanguages, t } = useLanguage();

  const getFlagEmoji = (code) => {
    const flags = {
      en: '🇬🇧',
      fr: '🇫🇷',
      es: '🇪🇸',
    };
    return flags[code] || '🌐';
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Select value={language} onValueChange={setLanguage}>
        <SelectTrigger className="w-[140px] bg-black/50 border-gray-700 hover:bg-black/70 transition-colors text-white">
          <SelectValue>
            <span className="text-white">{availableLanguages.find(l => l.code === language)?.nativeName}</span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="bg-black/95 border-gray-700 text-white">
          {availableLanguages.map((lang) => (
            <SelectItem 
              key={lang.code} 
              value={lang.code}
              className="hover:bg-white/10 cursor-pointer focus:bg-white/10 text-white"
            >
              <div className="flex items-center gap-2">
                <span className="text-white">{lang.nativeName}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageSelector;
